<template>
  <div>
    <div class="tips-section">
      <div class="title">温馨提示：</div>
      <div class="no">1. 本月可开发票只针对服务费以及注册费。</div>
      <div class="no">
        2. 本月产生的服务费以及注册费在下个月二号以后才可以索取发票。
      </div>
      <div class="no">3. 发票基于订单开具，不可拆分开票。</div>
      <div class="no">
        4.智绘网络单张发票金额限额100万，索取金额超过100万将拆分成多张发票开具。
      </div>
    </div>
    <div class="condition-section">
      <div class="cond-row">
        <div class="item">
          <div style="margin-right: 10px">状态类型：</div>
          <Select
            class="height45"
            v-model="searchObj.invoiceStatus"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in invoiceStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <div class="item" style="margin-right: 60px">
          <div style="margin-right: 10px">交易时间：</div>
          <DatePicker
            class="height45"
            v-model="searchObj.startAtStr"
            @on-change="handleChange"
            type="daterange"
            placeholder="请输入交易时间"
            style="width: 200px"
            clearable
          ></DatePicker>
        </div>
        <div class="item">
          <Button
            class="btn-height45"
            type="primary"
            style="margin-right: 20px"
            @click="onSearch"
            >搜索</Button
          >
          <Button class="btn-height45" @click="onSearchCancel">重置</Button>
        </div>
      </div>
    </div>
    <div class="table-data">
      <div class="total">搜索结果（{{ searchObj.total }}）</div>
      <Table
        class="domain-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="status" slot-scope="{ row }">
          <span>{{ row.invoiceStatus | expressNumFilter }}</span>
        </template>
        <template slot="op" slot-scope="{ row }">
          <span
            class="inline-block margin-l-10 color-bbb pointer border-ed1d33 radius-4 padding-v-5 padding-h-10"
            @click="toDetailsEvent(row.id)"
            >详情</span
          >
          <span
            v-if="row.invoiceStatus < 3"
            class="inline-block margin-l-10 color-bbb pointer border-ed1d33 radius-4 padding-v-5 padding-h-10"
            @click="cancelInvoiceEvent(row.id)"
            >取消申请</span
          >
        </template>
      </Table>
      <div class="page-tool">
        <Page
          :current="searchObj.page"
          :total="searchObj.total"
          :page-size="searchObj.limit"
          @on-change="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { invoiceCancel, invoiceList } from "api/user.js";
export default {
  name: "invoice",
  filters: {
    expressNumFilter(val) {
      let title = "--";
      switch (val) {
        case 0:
          title = "未处理";
          break;
        case 1:
          title = "待审核";
          break;
        case 2:
          title = "待开票";
          break;
        case 3:
          title = "已开票";
          break;
        case 4:
          title = "待寄出";
          break;
        case 5:
          title = "已寄出";
          break;
        case 6:
          title = "审核未通过";
          break;
        case 7:
          title = "用户取消";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      invoiceStatusList: [
        {
          label: "未处理",
          value: 0,
        },
        {
          label: "待审核",
          value: 1,
        },
        {
          label: "待开票",
          value: 2,
        },
        {
          label: "已开票",
          value: 3,
        },
        {
          label: "待寄出",
          value: 4,
        },
        {
          label: "已寄出",
          value: 5,
        },
        {
          label: "审核未通过",
          value: 6,
        },
        {
          label: "用户取消",
          value: 7,
        },
      ],
      searchObj: {
        startAtStr: "",
        startAt: "",
        endAt: "",
        invoiceStatus: null,
        page: 1,
        limit: 20,
        total: 0,
      },
      columns: [
        {
          title: "发票金额",
          key: "invoiceAmount",
          align: "center",
        },
        {
          title: "发票抬头",
          key: "title",
          align: "center",
        },
        {
          title: "申请时间",
          key: "createdAt",
          align: "center",
        },
        {
          title: "快递单号",
          key: "expressNo",
          align: "center",
        },
        {
          title: "状态",
          ellipsis: true,
          slot: "status",
          align: "center",
        },
        {
          title: "操作",
          ellipsis: true,
          slot: "op",
          align: "center",
        },
      ],
      data: [],
      tableLoading: false,
    };
  },
  created(){
    this.onPageChange(1);
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        let params = {
          page: this.searchObj.page,
          limit: this.searchObj.limit,
          endAt: this.searchObj.endAt,
          startAt: this.searchObj.startAt,
        };
        this.searchObj.invoiceStatus !== -1 &&
          (params.invoiceStatus = this.searchObj.invoiceStatus);
        this.tableLoading = true;
        const { code, data } = await invoiceList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.searchObj.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.searchObj = this.$options.data().searchObj;
      this.onPageChange(1);
    },
    // 时间变化
    handleChange(val) {
      this.searchObj.startAtStr = val;
    },
    // 取消申请
    cancelInvoiceEvent(id) {
      this.$Modal.confirm({
        title: "取消确认",
        content: "<p>确定要取消申请此发票吗？</p>",
        onOk: async () => {
          let res = await invoiceCancel({ id });
          res = res.data;
          if (res.code === 200) {
            this.$Message.success("取消成功！");
            this.onPageChange(1);
          }
        },
      });
    },
    toDetailsEvent(id) {
      this.$router.push({ path: "/user/invoice/info", query: { id: id } });
    },
  },
};
</script>
<style lang="less" scoped>
.tips-section {
  padding: 30px 50px 30px;
  background-color: #fff;
  border-radius: 8px;
  .title {
    color: #333333;
    font-size: 14px;
    font-weight: Bold;
    line-height: 36px;
  }
  .no {
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    line-height: 36px;
  }
}
.condition-section {
  margin: 40px 0 0;
  background-color: #fff;
  padding: 40px 20px;
  .cond-row {
    display: flex;
    flex-wrap: wrap;
    line-height: 60px;
    .item {
      display: flex;
      align-items: center;
      margin: 0 20px;
    }
  }
}
.tname {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.total {
  line-height: 80px;
  font-size: 18px;
  color: #3992e9;
  font-weight: bold;
}
.table-data {
  margin: 40px 0;
  background-color: #fff;
  padding: 20px 20px;
}
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.domain-table {
  .ivu-table-header th {
    background-color: #f0f3f6;
  }
  .ivu-table-header th,
  .ivu-table-body td {
    height: 80px;
  }
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
